<template>
  <div>
    <section role="main" class="empty">
      <div class="container">
        <div class="row icon-tabs">
          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item">
              <router-link to="/executive" class="nav-link"
                ><img src="/img/icons/executives.png" alt="Executives" />
                Executives</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/company" class="nav-link"
                ><img src="/img/icons/companies.png" alt="Companies" />
                Companies</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/news" class="nav-link"
                ><img src="/img/icons/deals.png" alt="News" /> News</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/deals-transactions" class="nav-link"
                ><img src="/img/icons/deals.png" alt="Deals & Transactions" />
                Deals & Transactions</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/listing" class="nav-link"
                ><img src="/img/book.png" style="height: 23px" />
                Listing</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/commentaries" class="nav-link active"
                ><img src="/img/icons/commentaries.png" alt="Commentaries" />
                Commentaries</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/interesting-bites" class="nav-link"
                ><img
                  src="/img/icons/interesting.png"
                  alt="Interesting Facts"
                />
                Interesting Facts</router-link
              >
            </li>
            <!-- NOTE: Temporary hide the open position tab. -->
            <!-- <li class="nav-item">
              <router-link to="/open-positons-new" class="nav-link"
                ><img src="/img/icons/position.png" alt="Open Position" /> Open
                Positons</router-link
              >
            </li> -->
            <li class="">
              <a
                class="nav-link"
                style="
                  font-weight: bold !important;
                  margin-top: 8px;
                  font-size: 13px;
                  color: #1f3342;
                "
              >
                {{ count }}</a
              >
            </li>
          </ul>
          <div id="fivethmenu" class="tab-content mb-3">
            <div class="container px-0">
              <div class="row">
                <div class="col-lg-12 col-sm-12">
                  <!-- <form class="form-search form-inline"> -->
                  <input
                    type="text"
                    class="search-query"
                    style="border: 0px none; width: 100%"
                    placeholder="Search..."
                    v-on:keyup.enter="getList(0)"
                    v-model="searchObj.keyword"
                  />
                  <!-- </form> -->
                </div>
              </div>
              <hr class="mt-0 mb-2" />
            </div>
            <div class="row">
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">Company</label>
                <Multiselect
                  mode="single"
                  trackBy="company_name"
                  label="company_name"
                  valueProp="id"
                  placeholder="Select"
                  v-model="searchObj.company_id"
                  :options="companyList"
                  :noOptionsText="'Enter Text'"
                  searchable="true"
                  v-on:change="geteComponydetail($event)"
                  @search-change="searchCompanyName($event)"
                />
              </div>
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">Select Topic</label>
                <Multiselect
                  mode="single"
                  trackBy="topic_name"
                  label="topic_name"
                  valueProp="id"
                  v-model="searchObj.topic_id"
                  :options="topicList"
                  searchable="true"
                  placeholder="Select"
                  @search-change="searchTopicName($event)"
                />
              </div>
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">From Date</label>
                <datepicker
                  v-model="searchObj.from_date"
                  inputFormat="dd/MM/yyyy"
                  placeholder="From Date"
                  class="form-control"
                  style="background-color: white !important; height: 35px"
                  :clearable="false"
                  :upperLimit="searchObj.to_date ? searchObj.to_date : new Date()"
                  @click="onClickFromDate()"
                >
                </datepicker>
              </div>
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">To Date</label>
                <datepicker
                  v-model="searchObj.to_date"
                  inputFormat="dd/MM/yyyy"
                  class="form-control"
                  placeholder="To Date"
                  :clearable="false"
                  style="background-color: white !important; height: 35px"
                  :lowerLimit="searchObj.from_date ? searchObj.from_date : null"
                  :upperLimit="new Date()"
                  @click="onClickFromDate()"
                >
                </datepicker>
              </div>
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">Date Period</label>
                <Multiselect
                  mode="single"
                  trackBy="value"
                  label="value"
                  valueProp="id"
                  v-model="searchObj.date_period"
                  :options="date_periods"
                  searchable="true"
                  placeholder="Select"
                  @change="dateFilter($event)"
                  @click="onClickDatePeriod()"
                />
              </div>
              <div class="col-lg-2 col-sm-4 col-6">
                <!-- <label></label> -->
                <button
                  type="button"
                  style="margin-top: 23px; width: 50%"
                  v-on:click="getList(0)"
                  class="apply-btn mr-1"
                >
                  Apply
                </button>
                <button
                  v-on:click="resetFilter()"
                  type="button"
                  style="margin-top: 23px; width: 40%"
                  class="apply-btn"
                >
                  Reset
                </button>
                <!--  <div class="text-center"><a href="#" class="advance-search">Advance Search</a></div> -->
              </div>
              <div class="col-lg-2 col-sm-4 col-6 mt-2">
                <label class="label">Deal Stage</label>
                <Multiselect
                  mode="single"
                  trackBy="name"
                  label="name"
                  valueProp="id"
                  v-model="searchObj.deal_stage_id"
                  :options="dealStageList"
                  searchable="true"
                  placeholder="Select"
                  @search-change="searchDealStage($event)"
                />
              </div>
              <div class="col-lg-2 col-sm-4 col-6 mt-2">
                <label class="label">Industry</label>
                <Multiselect
                  mode="single"
                  trackBy="industry_name"
                  label="industry_name"
                  valueProp="id"
                  v-model="searchObj.industry_id"
                  :options="industryList"
                  searchable="true"
                  placeholder="Select"
                  @change="closesub($event)"
                  @input="onIndustryChange"
                  @search-change="searchIndustryName($event)"
                />
              </div>
              <div v-if="isShowSubsector" class="col-lg-2 col-sm-4 col-6">
                <label class="label">Subsector</label>
                <Multiselect
                  mode="single"
                  trackBy="industry_name"
                  label="industry_name"
                  valueProp="id"
                  v-model="searchObj.subsector_id"
                  :options="subsectorList"
                  searchable="true"
                  placeholder="Select"
                />
              </div>
            </div>
            <hr />
            <div class="row mt-4">
              <div class="col-lg-7 col-sm-8">
                <div v-for="(data, index) in list" :key="index">
                  <div class="row">
                    <div
                      class="col-lg-2 col-sm-2 col-2 text-center"
                      style="cursor: pointer"
                      v-on:click="
                        $router.push('/executive-detail/' + data.executive_id)
                      "
                    >
                      <img
                        :title="
                          data.executive && data.executive.executive_name
                            ? data.executive.executive_name
                            : ''
                        "
                        :src="
                          data.executive && data.executive.executive_logo
                            ? data.executive.executive_logo
                            : data.executive && data.executive.gender == 'male'
                            ? '/img/male.png'
                            : data.executive &&
                              data.executive.gender == 'female'
                            ? '/img/female.png'
                            : '/img/user-pic.png'
                        "
                        alt=""
                        class="md-img"
                      />
                      <br />
                      <span class="update-date">{{
                        $helperService.getFormatedDate(data.published_date)
                      }}</span>
                    </div>
                    <div
                      style="cursor: pointer"
                      class="col-lg-8 col-sm-8 col-7"
                    >
                      <div class="" v-if="data.comment.length <= 200">
                        {{ data.comment }}
                      </div>
                      <div
                        style="font-weight: 400; font-size: 13.5px"
                        class=""
                        v-if="data.comment.length > 200"
                      >
                        {{ formattedBody(data) }}
                        <a
                          class="link cursor-pointer"
                          v-on:click="
                            data.showingFullText = !data.showingFullText
                          "
                        >
                          {{ data.showingFullText ? "Read less" : "Read more" }}
                        </a>
                      </div>

                      <div>
                        {{
                          data.topic && data.topic.topic_name
                            ? data.topic.topic_name
                            : ""
                        }}
                      </div>
                      <!-- <div class="text-right">
                      <a href="#">Read More</a>
                    </div> -->
                    </div>
                    <div
                      v-if="data.is_company_logo == 1"
                      class="col-lg-2 col-sm-2 col-3 text-center"
                      style="cursor: pointer"
                      v-on:click="openLink(data.source)"
                    >
                      <img
                        :title="
                          data.companey && data.companey.company_name
                            ? data.companey.company_name
                            : ''
                        "
                        :src="
                          data.companey && data.companey.company_logo
                            ? data.companey.company_logo
                            : '/img/new.png'
                        "
                        alt=""
                        height="100"
                        width="150"
                      />
                    </div>
                    <div
                      v-if="data.is_company_logo == 0"
                      v-on:click="openLink(data.source)"
                      style="cursor: pointer"
                      class="col-lg-2 col-sm-2 col-6 text-center"
                    >
                      <img
                        :title="
                          data.publication && data.publication.name
                            ? data.publication.name
                            : ''
                        "
                        :src="
                          data.publication && data.publication.publication_logo
                            ? data.publication.publication_logo
                            : ''
                        "
                        alt=""
                        height="100"
                        width="150"
                      />
                    </div>
                    <hr />
                  </div>
                  <hr />
                </div>
                <ErrorComponent @retry="getList(0)" ref="errorComponent" />
              </div>

              <div class="col-lg-5 col-sm-4">
                <canvas id="bar-chart6" class="mt-3 ml-3 canvas"> </canvas>
              </div>
            </div>
            <div class="row mx-0 mb-2">
              <div class="col-lg-12 mt-3 text-center">
                <div class="page-bottom-pagination text-right">
                  <Pagination
                    @page-change="pageChange"
                    @items-per-page-change="itemsPerPageChange"
                    ref="listPagination"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Chart from "chart.js/auto";
import ErrorComponent from "@/components/ErrorComponent";
import Pagination from "@/components/Pagination";
import datepicker from "vue3-datepicker";
import Multiselect from "@vueform/multiselect";
import moment from "moment";
export default {
  name: "News",
  components: {
    ErrorComponent,
    Pagination,
    // CountryFlag,
    // Field,
    Multiselect,
    datepicker,
  },
  data() {
    return {
      id: this.$route.params.id,
      loader: true,
      isShowSubsector: false,
      count: 0,
      searchObj: {
        keyword: "",
        type: "",
        from_date: "",
        to_date: "",
        industry_id: "",
        topic_id: "",
        company_id: "",
        deal_stage_id: "",
        subsector_id: "",
        date_period: "",
      },
      date_periods: [
        "Last Month",
        "Last 3 Month",
        "Last 6 Month",
        "Last 1 Year",
      ],
      industryList: [],
      companyList: [],
      topicList: [],
      commentryMovesPerDay: [],
      offset: -1,
      list: [],
      company_ids: [],
      dealStageList: [],
      subsectorList: [],
      subsectorKeyword: "",
      companyKeyword: "",
      industryKeyword: "",
      topicKeyword: "",
      dealStageKeyword: "",
    };
  },
  mounted() {
    if (this.id) {
      this.getExecutiveDetail(this.id);
    } else {
      this.getList(0);
    }
    this.industrylist();
    this.topiclist();
    this.getCommentryMoveByYear();
    this.getDealStageList();
  },

  methods: {
    resetFilter() {
      this.searchObj = {};
      this.searchObj.type = "";
      this.searchObj.keyword = "";
      this.searchObj.from_date = "";
      this.searchObj.to_date = "";
      this.searchObj.industry_id = "";
      this.searchObj.job_function_id_new = "";
      this.searchObj.topic_id = "";
      this.searchObj.company_id = "";
      this.searchObj.deal_stage_id = "";
      this.searchObj.subsector_id = "";
      this.isShowSubsector = false;

      this.getList(0);
    },
    formattedBody(data) {
      if (data.showingFullText) {
        return data.comment;
      }
      return `${data.comment.slice(0, 200).trim()}...`;
    },
    getExecutiveDetail(id) {
      if (id) {
        this.searchObj.company_id = id;
        this.company_ids.push(id);
      }
      this.companylist();
      this.getList(0);
    },
    openLink(url) {
      window.open(url);
    },
    geteComponydetail(id) {
      if (id) {
        this.$api
          .getAPI({
            _action: "/company/detail/" + id,
          })

          .then((res) => {
            this.searchObj.industry_id = res.industry_id;
          })
          .catch(() => {});
      }
    },
    getCommentryMoveByYear() {
      this.$api
        .getAPI({
          _action: "/commentry/moves/year",
        })
        .then((res) => {
          this.commentryMovesPerDay = res;
          this.getGraphCommentryMoveByDay();
        })
        .catch(() => {});
    },
    getGraphCommentryMoveByDay() {
      this.labelsArr = [];
      this.revanueArr = [];

      for (var i = 0; i < this.commentryMovesPerDay.length; i++) {
        var topic_name = this.commentryMovesPerDay[i].topic_name;
        this.labelsArr.push(topic_name);
        var revanue = this.commentryMovesPerDay[i].count;
        this.revanueArr.push(revanue);
      }
      if (this.sales) {
        this.sales.destroy();
      }
      const ctx = document.getElementById("bar-chart6").getContext("2d");
      this.myChart = new Chart(ctx, {
        type: "pie",
        data: {
          labels: this.labelsArr,
          datasets: [
            {
              data: this.revanueArr,
              backgroundColor: [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)",
                "rgba(75, 192, 192, 1)",
                "rgba(235, 52, 235)",
                "rgba(153, 102, 255, 1)",
                "rgba(255, 159, 64, 1)",
                "rgba(72, 245, 66)",
              ],
              borderColor: "#87CEEB",
              borderWidth: 0,
            },
          ],
        },
        options: {
          responsive: true,
          aspectRatio: 1,
          plugins: {
            legend: {
              display: true,
            },
          },
          scales: {
            y: {
              display: false,
            },
            x: {
              display: false,
            },
          },
        },
      });
    },
    searchTopicName(e) {
      this.topicKeyword = e;
      this.topiclist();
    },
    searchIndustryName(e) {
      this.industryKeyword = e;
      this.industrylist();
    },
    searchCompanyName(e) {
      this.companyKeyword = e;
      this.companylist();
    },
    companylist() {
      var obj = {};
      if (this.companyKeyword) {
        obj.keyword = this.companyKeyword;
      }
      if (this.company_ids) {
        obj.company_ids = this.company_ids;
      }
      this.$api
        .getAPI({
          _action: "/company/list",
          _body: obj,
        })
        .then((res) => {
          if (this.companyKeyword || this.company_ids?.length > 0) {
            this.companyList = res;
          } else {
            this.companyList = [];
          }
        })
        .catch(() => {});
    },
    searchDealStage(e) {
      this.dealStageKeyword = e;
      this.getDealStageList();
    },
    getDealStageList() {
      this.$api
        .getAPI({
          _action: "/deal/stage/list",
        })
        .then((res) => {
          this.dealStageList = res;
        })
        .catch(() => {});
    },
    topiclist() {
      var obj = {};
      if (this.topicKeyword) {
        obj.keyword = this.topicKeyword;
      }
      this.$api
        .getAPI({
          _action: "/topic/list",
          _body: obj,
        })
        .then((res) => {
          this.topicList = res;
        })
        .catch(() => {});
    },
    closesub(e) {
      if (!e) {
        this.searchObj.subsector_id = "";
      }
    },
    onIndustryChange(selectedIndustryId) {
      if (selectedIndustryId) {
        this.subsectorList = [];
        this.isShowSubsector = false;
        this.getSubsectorList(selectedIndustryId);
      } else {
        this.isShowSubsector = false;
      }
    },
    industrylist() {
      this.$api
        .getAPI({
          _action: "/industry/list",
        })
        .then((res) => {
          this.industryList = res;
        })
        .catch(() => {});
    },
    getSubsectorList(id) {
      this.$api
        .getAPI({
          _action: "/subsectors/list/" + id,
        })
        .then((res) => {
          this.subsectorList = res.list;

          // Only show subsector dropdown if there are subsectors(of industry) available
          if (this.subsectorList.length > 0) {
            this.isShowSubsector = true;
          } else {
            this.isShowSubsector = false;
          }
        })
        .catch(() => {
          this.isShowSubsector = false;
        });
    },
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    onClickFromDate() {
      this.searchObj.date_period = "";
    },
    dateFilter(e) {
      if (!e) {
        this.searchObj.date_period = '';
      }
    },
    onClickDatePeriod() {
      this.searchObj.from_date = "";
      this.searchObj.to_date = "";
    },
    getList(page) {
      this.$refs.errorComponent.updateListLoader(true);
      this.list = [];
      this.searchObj.offset = page;

      var obj = {};
      obj.offset = this.searchObj.offset;
      if (this.searchObj.from_date) {
        obj.from_date = moment(this.searchObj.from_date).format("DD-MM-YYYY");
      }
      if (this.searchObj.to_date) {
        obj.to_date = moment(this.searchObj.to_date).format("DD-MM-YYYY");
      }
      if (this.searchObj.date_period) {
        obj.date_period = this.searchObj.date_period;
      }
      if (this.searchObj.company_id) {
        obj.company_id = this.searchObj.company_id;
      }
      if (this.searchObj.company_id) {
        obj.company_id = this.searchObj.company_id;
      }
      if (this.searchObj.industry_id) {
        obj.industry_id = this.searchObj.industry_id;
      }
      if (this.searchObj.keyword) {
        obj.keyword = this.searchObj.keyword;
      }
      if (this.searchObj.deal_stage_id) {
        obj.deal_stage_id = this.searchObj.deal_stage_id;
      }
      if (this.searchObj.subsector_id) {
        obj.subsector_id = this.searchObj.subsector_id;
      }
      if (this.searchObj.topic_id) {
        obj.topic_id = this.searchObj.topic_id;
      }
      this.$api
        .getAPI({
          _action: "/commentary/pagination/list",
          _body: obj,
        })
        .then((res) => {
          this.loader = false;
          this.count = res.count;
          for (var i in res.list) {
            res.list[i].showingFullText = false;
          }
          this.list = res.list;
          this.offset = res.next_offset;
          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(
              res,
              "No commentaries list available"
            );
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
.multiselect {
  background: #f0f0f0;
  height: 35px;
  border: 1px solid;
}

.multiselect-tag {
  background: #9cc338 !important;
}
canvas {
  width: 420px !important;
  height: 420px !important;
}
</style>
